import { fromJS, Map } from 'immutable'

export const arrayToMap = (array, idField = 'id', transform = t => t) => {
  return fromJS(array).reduce((map, item) => map.set(item.get(idField), transform(item)), Map())
}
